import * as React from 'react';
import { useState, useMemo } from 'react';
import '../styles/home.css';
import '../styles/amazon-theme.css';
import logo from '../assets/awesomepdftools-title-logo.png';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MergePDF from './pdf-merger';
import SplitPDF from './split-pdf';
import ImageToPdf from './image-to-pdf';
import MergeFiles from './files-merger';
import DocxToPdf from './docx-to-pdf';
import PageNumbers from './PageNumbers';
import SignPDF from './sign-pdf';
import Watermark from './watermark';
import OrganizePDF from './organize-pdf';
import KeywordDetection from './keyword-detection';
import RedactionDetection from './redaction-detection';
import PdfToPng from './pdf-to-png';
import BasicDecrypt from './pdf-basic-decrypt';
import PdfToWord from './pdf-to-word';
import ResizeJpg from './resize-jpg';
import AddLogoToPdf from './add-logo-to-pdf';
import InsertImageToPdf from './insert-image-to-pdf';
import PdfComparator from './pdf-comparator';
import ConvertToGrayscale from './convert-to-grayscale';
// import JsonFormatter from './json-formatter';
// import JsonDiff from './json-diff';
import PdfAnnotator from './pdf-annotator';
import PdfPageEditor from './pdf-page-editor';
import TransparentBackground from './transparent-background';
import HeicConverter from './heic-converter';
import PasswordProtectPdf from './password-protect-pdf';
import FlattenPdf from './flatten-pdf';
import PdfOcr from './pdf-ocr';
import HtmlToPdf from './html-to-pdf';
import RedactPdf from './redact-pdf';

// Tool metadata for filtering
const toolsConfig = [
  { id: 'merge', component: MergePDF, name: 'Merge PDF', category: 'merge', keywords: ['merge', 'combine', 'join'] },
  { id: 'split', component: SplitPDF, name: 'Split PDF', category: 'merge', keywords: ['split', 'separate', 'divide'] },
  {
    id: 'image-to-pdf',
    component: ImageToPdf,
    name: 'Image to PDF',
    category: 'convert',
    keywords: ['image', 'jpg', 'png', 'convert', 'photo'],
  },
  {
    id: 'combine-files',
    component: MergeFiles,
    name: 'Combine Files',
    category: 'merge',
    keywords: ['combine', 'merge', 'files', 'docx', 'image'],
  },
  {
    id: 'pdf-to-png',
    component: PdfToPng,
    name: 'PDF to PNG',
    category: 'convert',
    keywords: ['png', 'image', 'convert', 'export'],
  },
  // {
  //   id: 'pdf-to-word',
  //   component: PdfToWord,
  //   name: 'PDF to Word',
  //   category: 'convert',
  //   keywords: ['word', 'docx', 'convert', 'editable'],
  // },

  {
    id: 'resize-jpg',
    component: ResizeJpg,
    name: 'Resize JPG',
    category: 'convert',
    keywords: ['resize', 'jpg', 'jpeg', 'image', 'dimensions', 'scale'],
    isNew: true,
  },
  {
    id: 'add-logo',
    component: AddLogoToPdf,
    name: 'Add Logo to PDF',
    category: 'edit',
    keywords: ['logo', 'watermark', 'brand', 'image', 'stamp'],
    isNew: true,
  },
  {
    id: 'insert-image',
    component: InsertImageToPdf,
    name: 'Insert Images in PDF',
    category: 'edit',
    keywords: ['insert', 'image', 'photo', 'picture', 'jpg', 'png', 'graphics'],
    isNew: true,
  },
  {
    id: 'pdf-comparator',
    component: PdfComparator,
    name: 'PDF Comparator',
    category: 'analyze',
    keywords: ['compare', 'diff', 'difference', 'test', 'prod', 'mismatch'],
    isNew: true,
  },
  {
    id: 'grayscale',
    component: ConvertToGrayscale,
    name: 'Convert to Grayscale',
    category: 'convert',
    keywords: ['grayscale', 'black', 'white', 'bw', 'monochrome', 'gray'],
    isNew: true,
  },
  // {
  //   id: 'json-formatter',
  //   component: JsonFormatter,
  //   name: 'JSON Formatter',
  //   category: 'convert',
  //   keywords: ['json', 'format', 'beautify', 'minify', 'validate', 'pretty'],
  //   isNew: true,
  // },
  // {
  //   id: 'json-diff',
  //   component: JsonDiff,
  //   name: 'JSON Diff',
  //   category: 'analyze',
  //   keywords: ['json', 'diff', 'compare', 'difference', 'delta', 'changes'],
  //   isNew: true,
  // },
  {
    id: 'pdf-annotator',
    component: PdfAnnotator,
    name: 'PDF Annotator',
    category: 'edit',
    keywords: ['annotate', 'draw', 'text', 'shape', 'freehand', 'edit', 'rectangle', 'circle', 'line', 'pen'],
    isNew: true,
  },
  {
    id: 'page-editor',
    component: PdfPageEditor,
    name: 'PDF Page Editor',
    category: 'edit',
    keywords: ['add', 'delete', 'remove', 'blank', 'page', 'insert', 'edit', 'view'],
    isNew: true,
  },
  {
    id: 'transparent-bg',
    component: TransparentBackground,
    name: 'Transparent Background',
    category: 'convert',
    keywords: ['transparent', 'background', 'remove', 'png', 'jpg', 'jpeg', 'cutout', 'alpha'],
    isNew: true,
  },
  {
    id: 'heic-converter',
    component: HeicConverter,
    name: 'HEIC Converter',
    category: 'convert',
    keywords: ['heic', 'heif', 'convert', 'png', 'jpeg', 'jpg', 'iphone', 'photo', 'image'],
    isNew: true,
  },
  { id: 'sign', component: SignPDF, name: 'Sign PDF', category: 'edit', keywords: ['sign', 'signature', 'digital'] },
  {
    id: 'watermark',
    component: Watermark,
    name: 'Watermark',
    category: 'edit',
    keywords: ['watermark', 'stamp', 'text'],
  },
  {
    id: 'organize',
    component: OrganizePDF,
    name: 'Organize PDF',
    category: 'edit',
    keywords: ['organize', 'reorder', 'rotate', 'pages'],
  },
  {
    id: 'keyword',
    component: KeywordDetection,
    name: 'Keyword Detection',
    category: 'analyze',
    keywords: ['keyword', 'search', 'find', 'analyze'],
  },
  {
    id: 'redaction',
    component: RedactionDetection,
    name: 'PDF Falsified Detector',
    category: 'analyze',
    keywords: ['redact', 'falsified', 'detect', 'analyze'],
  },
  {
    id: 'page-numbers',
    component: PageNumbers,
    name: 'Page Numbers',
    category: 'edit',
    keywords: ['page', 'number', 'numbering'],
  },
  {
    id: 'decrypt',
    component: BasicDecrypt,
    name: 'Remove Encryption',
    category: 'security',
    keywords: ['decrypt', 'unlock', 'encryption', 'password'],
  },
  {
    id: 'password-protect',
    component: PasswordProtectPdf,
    name: 'Password Protect PDF',
    category: 'security',
    keywords: ['password', 'protect', 'encrypt', 'aes', 'lock', 'secure', 'encryption'],
    isNew: true,
  },
  {
    id: 'redact',
    component: RedactPdf,
    name: 'Redact PDF',
    category: 'security',
    keywords: ['redact', 'remove', 'hide', 'sensitive', 'black', 'censor', 'permanent', 'private'],
    isNew: true,
  },
  {
    id: 'flatten',
    component: FlattenPdf,
    name: 'Flatten PDF',
    category: 'edit',
    keywords: ['flatten', 'merge', 'layers', 'flat', 'rasterize', 'forms', 'annotations'],
    isNew: true,
  },
  {
    id: 'pdf-ocr',
    component: PdfOcr,
    name: 'PDF OCR',
    category: 'convert',
    keywords: ['ocr', 'searchable', 'scan', 'recognize', 'text', 'selectable', 'accessibility'],
    isNew: true,
  },
  {
    id: 'html-to-pdf',
    component: HtmlToPdf,
    name: 'Convert HTML to PDF',
    category: 'convert',
    keywords: ['html', 'htm', 'web', 'page', 'convert', 'pdf'],
    isNew: true,
  },
  {
    id: 'docx-to-pdf',
    component: DocxToPdf,
    name: 'Word to PDF',
    category: 'convert',
    keywords: ['word', 'docx', 'convert', 'document'],
    isBeta: true,
  },
];

const Home = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredTools = useMemo(() => {
    return toolsConfig.filter((tool) => {
      // Category filter
      const categoryMatch = activeCategory === 'all' || tool.category === activeCategory;

      // Search filter
      const searchLower = searchQuery.toLowerCase().trim();
      const searchMatch =
        !searchLower ||
        tool.name.toLowerCase().includes(searchLower) ||
        tool.keywords.some((kw) => kw.includes(searchLower));

      return categoryMatch && searchMatch;
    });
  }, [searchQuery, activeCategory]);

  return (
    <div>
      <Header
        logo={logo}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
      />

      <section className="welcome-section">
        <h1 className="welcome-title">
          Welcome to Awesome PDF Tools
        </h1>
        <p className="welcome-subtitle">
          Awesome PDF Tools is a client-side PDF processing toolkit. Merge, split, combine and convert PDFs with just a
          few clicks. Everything runs locally in your browser — no files are ever uploaded.
        </p>
      </section>

      <div className="services-grid">
        {filteredTools.length > 0 ? (
          filteredTools.map((tool) => {
            const Component = tool.component;
            return <Component key={tool.id} isNew={tool.isNew} isBeta={tool.isBeta} />;
          })
        ) : (
          <div className="no-results">
            <p>No tools found matching "{searchQuery}"</p>
            <button
              className="category-pill"
              onClick={() => {
                setSearchQuery('');
                setActiveCategory('all');
              }}
            >
              Clear filters
            </button>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Home;
